import { render, staticRenderFns } from "./ProductAgoraDocumentationError.vue?vue&type=template&id=732be520&scoped=true&"
import script from "./ProductAgoraDocumentationError.vue?vue&type=script&lang=js&"
export * from "./ProductAgoraDocumentationError.vue?vue&type=script&lang=js&"
import style0 from "./ProductAgoraDocumentationError.vue?vue&type=style&index=0&id=732be520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732be520",
  null
  
)

export default component.exports